import React from 'react';
import classNames from 'classnames';
import Icon from '../../design-system/icon.jsx';
import Spinner from '../../design-system/spinner.jsx';

export const Quantity = ({
  amount,
  className,
  onIncreaseQuantity,
  onDecreaseQuantity,
  isPending = false
}) => {
  const isDecreaseDisabled = amount <= 1;

  return (
    <div
      aria-busy={isPending}
      className={classNames('quantity-toggle__container noselect', className, {
        'quantity-toggle__container--pending': isPending
      })}
    >
      <button
        aria-label="Decrease quantity"
        className={classNames('quantity-toggle__button', {
          'quantity-toggle__button--disabled': isDecreaseDisabled
        })}
        disabled={isDecreaseDisabled}
        onClick={isPending ? undefined : onDecreaseQuantity}
        type="button"
      >
        <Icon type="minus" />
      </button>
      {isPending ? (
        <div className="quantity-toggle__amount quantity-toggle__amount--pending">
          <Spinner color="black" inline />
        </div>
      ) : (
        <input
          className="quantity-toggle__amount"
          id="quantity"
          min="0"
          name="quantity"
          readOnly
          tabIndex={-1}
          type="number"
          value={amount}
        />
      )}
      <span aria-live="polite" className="screenreader">Quantity: {amount}</span>
      <button
        aria-label="Increase quantity"
        className='quantity-toggle__button'
        onClick={isPending ? undefined : onIncreaseQuantity}
        type="button"
      >
        <Icon type="plus" />
      </button>
    </div>
  );
};
